import { render, staticRenderFns } from "./ShiftTrucksInfoTable.vue?vue&type=template&id=2b39181e"
import script from "./ShiftTrucksInfoTable.vue?vue&type=script&lang=js"
export * from "./ShiftTrucksInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports